var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.subPrice(_vm.detail.product_price, "1")
  var m1 = _vm.subPrice(_vm.detail.product_price, "2")
  var a0 = {
    startstamp: _vm.detail.preview.start_time,
    endstamp: _vm.detail.preview.end_time,
    type: "preview",
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        a0: a0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }